import { useState } from "react";
import PropTypes from "prop-types";
import GrTextField from "src/design-system/components/GrTextField";
import GrButton from "src/design-system/components/GrButton";
import { gr } from "src/design-system/tokens";

// Labels always above the fields: a browser that autofills on load does not tell the page until the
// field is clicked, so a floating label would sit on top of the saved email / password.
const LABEL_ABOVE = { shrink: true };

export default function EmailForm({
  onhandleEmailSubmit,
  setIsLoading,
  isLoading,
}) {
  const [email, setEmail] = useState("");
  const handleSubmit = (e) => {
    setIsLoading(true);
    e.preventDefault();
    if (!email) {
      return;
    }
    onhandleEmailSubmit(email);
  };
  return (
    <form autoComplete="off" onSubmit={handleSubmit}>
      <GrTextField
          InputLabelProps={LABEL_ABOVE}
        required
        value={email}
        onChange={(e) => setEmail(e.target.value)}
        autoComplete="username"
        type="email"
        label="Email address"
      />
      {/* The button only changes its text while sending (as before), it is not disabled. */}
      <GrButton type="submit" size="lg" fullWidth sx={{ mt: gr.space[6] }}>
        {isLoading ? "Submiting..." : "Submit"}
      </GrButton>
    </form>
  );
}

EmailForm.propTypes = {
  onhandleEmailSubmit: PropTypes.func.isRequired,
  setIsLoading: PropTypes.func.isRequired,
  isLoading: PropTypes.bool,
};
